module.exports = __webpack_public_path__ + "static/media/amazed.36a3f6da.jpg";